import TheFooterInner from "layout/TheFooterInner/TheFooterInner";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
const TheFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      {/* {location.pathname !== "/information" && <TheFooterInner />} */}
      <footer>
        <ul>
          {/* <li className="flex-box">
            <div>
              <img src="assets/img/icon/hotline.svg" />{" "}
              <span>1900 633 ???</span>
            </div>
            <div>
              <img src="assets/img/icon/facebook.svg" />{" "}
              <a
                target={"_blank"}
                href="https://www.facebook.com/DuyTan.Plastics.Corp"
              >
                <span>P/S</span>
              </a>
            </div>
          </li> */}

          <li>
            <span>
              Bản quyền thuộc về Công ty TNHH Quốc tế Unilever Việt Nam  Powered by Utop
            </span>
          </li>
        </ul>
      </footer>
    </>
  );
};

export default TheFooter;
